<div class="avano-combobox-input-with-button" (click)="overlayToggle($event)" #container [class.avano-combobox-disabled]="disabled">
  <div class="avano-combobox-input-labels">
    <div *ngIf="selectedEntry" class="avano-combobox-selected-item">
      <span class='avano-combobox-selected-item-label'>
        <ng-container *ngIf="!selectedItemTemplate">
          {{ getOptionLabel(selectedEntry) }}
        </ng-container>
        <ng-container *ngTemplateOutlet="selectedItemTemplate; context: { $implicit: selectedEntry }"></ng-container>
      </span>
      <span class="avano-combobox-selected-item-clear" (click)="clear($event)">
        <i class="icon-content-cancel"></i>
      </span>
    </div>
  </div>
  <div class="avano-combobox-input-button">
    <i class="icon-content-chevron-down"></i>
  </div>

  <div
    class="avano-combobox-overlay"
    *ngIf="overlayVisible"
    [@overlayAnimation]="{
      value: 'visible',
      params: { showTransitionParams: '.12s cubic-bezier(0, 0, 0.2, 1)', hideTransitionParams: '.1s linear' }
    }"
    (@overlayAnimation.start)="onOverlayAnimationStart($event)"
  >
    <ng-template [ngIf]="enableFilter" [ngIfElse]="defaultSelectionContainer">
      <div class="avano-combobox-filter-container">
        <input #filterInput
               type="text"
               role="textbox"
               [placeholder]='enableNewEntry ? labelFilterCreate : labelFilter'
               (input)="onFilterInputChange(filterInput.value)" />
        <i class="icon-content-search"></i>
      </div>
      <ng-container *ngTemplateOutlet="defaultSelectionContainer"></ng-container>

      <div class="avano-combobox-entry-new" *ngIf="enableFilter && isNotSelectable(filterInput.value)" (click)="createNewEntry(filterInput.value)">
        <span class='avano-combobox-entry-new-value'>{{ filterInput.value }}</span>
        <span class='avano-combobox-entry-new-label'>({{ labelNew }})</span>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #defaultSelectionContainer>
  <div class="avano-combobox-select-container avano-scrollbars">
    <div *ngFor="let singleEntry of selectableEntriesFiltered"
         (click)="selectEntry(singleEntry)"
         class="avano-combobox-select-entry"
    [class.selected]='isEntrySelected(singleEntry)'>
      {{ getOptionLabel(singleEntry) }}
    </div>
  </div>
</ng-template>
